import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { RecordStatus } from "../../../../../../assets/data/enumData";
import { WADocType } from "../../../../../../assets/data/projectData";
import {
    AttachmentSection,
    Button,
    Divider,
    DocumentsList,
    FormFieldSet,
    Modal,
    PageHeader,
    PageTitle,
    useFormHandler,
} from "../../../../../../components";
import { transformFiles } from "../../../../../../utils/transformFiles";

const initialFormState = {
    eVerificationCaseNumber: "",
    eVerificationDate: "",
    eVerificationStatus: "",
    eVerifiedBy: "",
    eVerifiedDocument: "",
    expiryDate: "",
    attachments: [
        {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            documentStatus: "",
            expiryDate: "",
            chooseFiles: [],
        },
    ],
};

const ViewEverifyModel = ({ onClose, isOpen }) => {
    const [isEditable, setIsEditable] = useState(false);

    const {
        formData,
        errors,
        handleChange,
        validateAllFields,
        setFormData,
    } = useFormHandler(initialFormState, {
      attachments: [ { chooseFiles: { type: "file" } } ]
    });

    const handleEdit = () => {
        setIsEditable(true);
    };

    const handleCancel = () => {
        setIsEditable(false);
        onClose();
    };

    const handleSave = () => {
        const isValid = validateAllFields();
        if (!isValid) return;
        console.log("Saved Form Data:", formData);
        setIsEditable(false);
    };

    const getAttachmentError = (index, field) => {
        return errors?.attachments?.[index]?.[field] || "";
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            width="max-w-7xl"
            showCloseButton={false}
        >
            <div>
       
                <div className="flex justify-end mb-2">
                    <Button title="Edit" onClick={handleEdit} />
                </div>

         
                <div className="grid grid-cols-3 gap-x-6 gap-y-6 px-2 max-w-7xl">
                    <FormFieldSet
                        type="text"
                        title="E-Verification Case Number"
                        placeholder="Enter E-Verification Case Number"
                        value={formData.eVerificationCaseNumber}
                        onChange={(value) => handleChange("eVerificationCaseNumber", value)}
                        error={errors.eVerificationCaseNumber}
                        disabled={!isEditable}
                    />
                    <FormFieldSet
                        type="datepicker"
                        title="E-Verification Date"
                        placeholder="Select E-Verification Date"
                        value={formData.eVerificationDate}
                        onChange={(value) => handleChange("eVerificationDate", value)}
                        error={errors.eVerificationDate}
                        disabled={!isEditable}
                        showDropdown={false}
                    />
                    <FormFieldSet
                        type="select"
                        title="E-Verification Status"
                        placeholder="Select E-Verification Status"
                        value={formData.eVerificationStatus}
                        onChange={(value) => handleChange("eVerificationStatus", value)}
                        error={errors.eVerificationStatus}
                        options={RecordStatus}
                        disabled={!isEditable}
                    />
                    <FormFieldSet
                        type="select"
                        title="E-Verified By"
                        keyname="eVerifiedBy"
                        placeholder="Select Immigration Manager"
                        value={formData.eVerifiedBy}
                        onChange={(value) => handleChange("eVerifiedBy", value)}
                        options={[]}
                        disabled={!isEditable}
                    />
                    <FormFieldSet
                        type="select"
                        title="E-Verified Document"
                        placeholder="Select E-Verified Document"
                        value={formData.eVerifiedDocument}
                        onChange={(value) => handleChange("eVerifiedDocument", value)}
                        error={errors.eVerifiedDocument}
                        options={WADocType}
                        showSearch
                        disabled={!isEditable}
                    />
                    <FormFieldSet
                        type="datepicker"
                        title="Expiry Date"
                        placeholder="Select Expiry Date"
                        value={formData.expiryDate}
                        onChange={(value) => handleChange("expiryDate", value)}
                        error={errors.expiryDate}
                        disabled={!isEditable}
                        showDropdown={false}
                    />
                </div>

                {/* Attachments */}
                <div className="mt-4 mb-1 flex">
                    <PageHeader
                        Section={<PageTitle title="Attachments" tag="h6" />}
                    />
                </div>
                <Divider />

                <DocumentsList data={transformFiles([])} type="inner" />

                <AttachmentSection
                    attachments={formData.attachments}
                    onChange={(newAttachments) =>
                        setFormData({ ...formData, attachments: newAttachments })
                    }
                    getAttachmentError={getAttachmentError}
                    showNameField={true}
                    showCommentsField={true}
                    disabled={!isEditable}
                />      
                <div className="flex gap-3 justify-end my-8">
                    <Button title="Cancel" variant="outlined" onClick={handleCancel} />
                    {isEditable && <Button title="Save" onClick={handleSave} />}
                </div>
            </div>
        </Modal>
    );
};

export default ViewEverifyModel;